module.exports = __webpack_public_path__ + "static/media/resize-demo.af09a210.mp4";